<script lang="ts">
  import { WebsiteName } from "../../../config"
</script>

<svelte:head>
  <title>Cookie Policy - {WebsiteName}</title>
</svelte:head>

<div class="container mx-auto px-4 py-8">
  <div class="prose max-w-none">
    <h1>Cookie Policy</h1>
    <p class="text-muted-foreground">
      Last updated: {new Date().toLocaleDateString()}
    </p>

    <h2>1. What Are Cookies</h2>
    <p>
      Cookies are small text files that are placed on your computer or mobile
      device when you visit our website. They are widely used to make websites
      work more efficiently and provide useful information to website owners.
    </p>

    <h2>2. How We Use Cookies</h2>
    <p>We use cookies for the following purposes:</p>
    <ul>
      <li>Essential cookies: Required for the website to function properly</li>
      <li>Authentication cookies: To remember your login status</li>
      <li>Preference cookies: To remember your settings and preferences</li>
      <li>Analytics cookies: To understand how visitors use our website</li>
    </ul>

    <h2>3. Types of Cookies We Use</h2>
    <h3>Essential Cookies</h3>
    <p>
      These cookies are necessary for the website to function and cannot be
      switched off. They are usually only set in response to actions made by you
      which amount to a request for services.
    </p>

    <h3>Performance Cookies</h3>
    <p>
      These cookies allow us to count visits and traffic sources so we can
      measure and improve the performance of our site.
    </p>

    <h2>4. Managing Cookies</h2>
    <p>
      Most web browsers allow you to manage cookies through their settings
      preferences. However, if you limit the ability of websites to set cookies,
      you may impact your overall user experience.
    </p>

    <h2>5. Changes to This Cookie Policy</h2>
    <p>
      We may update our Cookie Policy from time to time. We will notify you of
      any changes by posting the new Cookie Policy on this page.
    </p>

    <h2>Contact Us</h2>
    <p>If you have any questions about our Cookie Policy, please contact us.</p>
  </div>
</div>
